import { render, staticRenderFns } from "./orderPackageManager.vue?vue&type=template&id=20f6f1bf"
import script from "./orderPackageManager.vue?vue&type=script&lang=js"
export * from "./orderPackageManager.vue?vue&type=script&lang=js"
import style0 from "./orderPackageManager.vue?vue&type=style&index=0&id=20f6f1bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports